import { QuantityBox } from '@commenda/kakashi';
import { TBillableProduct } from '@commenda/types/src/billing/types';
import { formatCurrency } from '@commenda/utils';
import { Currency } from '@prisma/client';
import { useBillingContext } from '../context';
import { billingPeriodDisplayNameMap, productDescriptions } from '../utils';

export const BillingItemCard = ({
  billingItem,
}: {
  billingItem: TBillableProduct;
}) => {
  const { onUnitChange, getProductDescription } = useBillingContext();
  return (
    <div
      className="pb-4 flex flex-col gap-2 md:flex-row md:justify-between border-b md:gap-6"
      key={billingItem.id}
    >
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          <h3 className="txt-extra-large-bold text-fg-primary">
            {billingItem.title}
          </h3>
          <p className="txt-small-regular text-fg-tertiary">
            {getProductDescription(billingItem) ||
              productDescriptions[billingItem.id]}
          </p>
        </div>
        <div className="flex items-center gap-2 txt-small-medium text-fg-tertiary">
          <span>
            {formatCurrency({
              price: billingItem.netPrice.price,
              currency: billingItem.netPrice.currency as Currency,
            })}
          </span>
          <div className="size-1 bg-fg-quinary rounded-full" />
          <span>
            {billingItem.netPrice.recurring?.interval
              ? billingPeriodDisplayNameMap[
                  billingItem.netPrice.recurring?.interval
                ]
              : 'One Time'}
          </span>
        </div>
      </div>
      <div className="flex items-center justify-between md:justify-start md:flex-col gap-1 md:items-end">
        <div className="flex gap-2 items-center justify-end">
          <span className="txt-extra-large-bold text-fg-primary">
            {formatCurrency({
              price: billingItem.totalPriceAfterDiscount,
              currency: billingItem.netPrice.currency as Currency,
            })}
          </span>
        </div>
        <QuantityBox
          quantity={billingItem.quantity}
          onChange={(qty) => onUnitChange(billingItem.id, qty)}
          minQuantity={billingItem.minimumQuantity}
          maxQuantity={null}
          disabled={!billingItem.customizable}
        />
      </div>
    </div>
  );
};
